import { safeRedirect } from '@/utils/safeRedirect';

const COOKIE = 'oauth_intent';
/** 10 min — bounds the OAuth roundtrip + replay window without surviving abandoned signups. */
const MAX_AGE = 600;

/** Pure — runs safeRedirect, URL-encodes, returns the cookie attribute string. */
export function buildOAuthIntentCookie(target: string, secure: boolean): string {
  const safe = safeRedirect(target, '/pricing');
  const base = `${COOKIE}=${encodeURIComponent(safe)}; path=/; max-age=${MAX_AGE}; SameSite=Lax`;
  return secure ? `${base}; Secure` : base;
}

/**
 * CLIENT — write the post-auth target as a short-lived cookie BEFORE signInWithOAuth.
 * SameSite=Lax preserves the cookie across the cross-site Google→callback roundtrip;
 * Strict would block it. Secure when HTTPS so modern browsers honor it.
 */
export function setOAuthIntent(target: string): void {
  document.cookie = buildOAuthIntentCookie(target, location.protocol === 'https:');
}
